import Driver from './driver';
import Team from './team';
import dayjs from 'dayjs';
import $AppConfig from '@/AppConfig';

export default class Race {
  id: number;
  name: string;
  seasonId: number;
  seasonOrder: number;
  greenFlagDateTime: Date;
  totalLaps: number;
  lapsCompleted: number;
  pickCount: number;
  salaryCap: number;
  status: string;
  fastRaceLapSpeed: number;
  logoUrl: string;
  drivers: Array<Driver>;
  team: Team;

  constructor(starter?: any) {
    starter = starter || {};
    // Deal with 0 Id's
    this.id = starter.id !== null && !isNaN(starter.id) ? starter.id : null;
    this.name = starter.name || null;
    this.seasonId = starter.seasonId || null;
    this.seasonOrder = starter.seasonOrder || null;
    this.greenFlagDateTime = starter.greenFlagDateTime
      ? new Date(`${starter.greenFlagDateTime}.593Z`)
      : new Date();
    this.totalLaps = starter.totalLaps || null;
    this.lapsCompleted = starter.lapsCompleted || null;
    this.pickCount = starter.pickCount || null;
    this.salaryCap = starter.salaryCap || null;
    this.status = starter.status || null;
    this.fastRaceLapSpeed = starter.fastRaceLapSpeed || null;
    this.logoUrl = starter.logoUrl || null;
    this.drivers = starter.drivers || null;
    // SEt Drivers
    this.drivers = starter.drivers || [];
    this.drivers = this.drivers.map((driver: any) => {
      return new Driver(driver);
    });
    this.team = starter.team ? new Team(starter.team) : new Team();
    // Fast
    // this.fastestLap = starter.fastestLap || 0;
  }

  // Is the greenFlagTime in the past?
  public greenFlagStarted(): boolean {
    return this.greenFlagDateTime.getTime() < new Date().getTime();
  }

  /**
   * Determine if the Picks for the Race are allowed
   * We're going to maintain the state here opposed to rely on the API
   * The GreenFlag time might start, but there could be a delay.
   * Users are stopped from picking a team once the greenflag time has passed.
   */
  public picksClosed(): boolean {
    // Status that denote closed picks
    const INPROGRESS = $AppConfig.status.IN_PROGRESS;
    const COMPLETE = $AppConfig.status.COMPLETE;
    // Default to False
    let isClosed = false;
    // Completed or in Progress
    let doneOrLive =
      [INPROGRESS, COMPLETE].indexOf(this.status) > -1 ? true : false;
    // Green Flat Time Passed
    let greenFlagPassed = this.greenFlagStarted();
    // If it's done
    if (doneOrLive) {
      isClosed = true;
      // If it's green flag started
    } else if (greenFlagPassed) {
      isClosed = true;
      // Else it's not closed.
    } else {
      isClosed = false;
    }
    return isClosed;
  }
}
